import { useEffect, useState } from 'react'
import api from '@/services/api'
import { fetchActiveLeadSourceNames } from '@/utils/leadSourceOptions.util'

export function useLeadSourceOptions() {
  const [options, setOptions] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setLoadError(false)

    fetchActiveLeadSourceNames((url) => api.get(url))
      .then(({ options: activeNames, loadError: failed }) => {
        if (cancelled) return
        setOptions(activeNames)
        setLoadError(failed)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  return { options, loading, loadError, isEmpty: !loading && options.length === 0 }
}
